<script>
import { mapState, mapActions } from 'vuex';
/* components */
import FullScreenOverlay from '@/components/FullScreenOverlay';
import Button from '@/components/Button';
/*  */
import { onboardingBackground } from '@/scripts/computed';
import { getPlatformIconUrl } from '@/scripts/utils/data';
import { requestConnectionCreation } from '@/scripts/api/connections';

/* tools */
import {} from '@/scripts/utils';

export default {
  name: 'ConnectSteam',
  components: {
    FullScreenOverlay,
    Button,
  },
  props: {
    activeGame: {
      type: String,
      required: true,
    },
    platform: {},
    linkTo: {
      type: String,
      default: '/onboarding/connect-game',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),

    onboardingBackground,
  },
  created() {
    if (!this.activeGame)
      this.$router.push({
        name: 'Onboarding',
        params: { option: 'connect-game', errorState: true },
      });
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    requestSteamLink() {
      const { activeGame, platform } = this;
      const params = { gameID: activeGame, platformID: platform };

      requestConnectionCreation(params).then(({ authorizationURL }) => {
        if (authorizationURL) window.location.href = authorizationURL;

        /* TODO: deprecated */
        /* window.open */
      });
    },
    getPlatformIconUrl,
  },
};
</script>

<template>
  <FullScreenOverlay
    :style="onboardingBackground"
    :class="{ shadowBg: onboardingBackground }"
  >
    <div class="onboarding">
      <div class="onboarding__top">
        <Button :back="true" class="back">
          <template #icon>
            <img :src="require(`@/assets/svg/arrow-left.svg`)" />
          </template>
        </Button>
      </div>
      <div class="onboarding__body">
        <div class="onboarding__row onboarding__row--head">
          <h1 class="onboarding__title">Please link your Steam Account</h1>
        </div>
        <div class="onboarding__row onboarding__row--steam">
          <Button @click="requestSteamLink" class="steam">
            <template #icon>
              <img :src="getPlatformIconUrl('steam')" />
            </template>
          </Button>
          <Button
            href="//support.playerrush.com/article/linking-your-steam-account-with-player-rush"
            class="link-white"
          >
            Why do you need this?
          </Button>
        </div>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.onboarding {
  &__top {
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__title {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    text-transform: uppercase;
    color: #ffc800;
    text-align: center;
    margin: 0;
  }

  &__row {
    &--steam {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-shrink: 0;
      max-width: 370px;
      width: 100%;
      margin-top: 50px;
      margin-left: auto;
      margin-right: auto;

      .steam + .link-white {
        margin-top: 20px;
      }
    }
  }
}

@media (max-width: $mobile) {
  .onboarding {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    &__top {
      min-height: 29px;
      margin-bottom: 30px;
      flex-shrink: 0;
    }

    &__title {
      font-size: 24px;
      line-height: 1.28;
    }

    &__row {
      &--steam {
        margin-top: 55px;

        .steam + .link-white {
          margin-top: 25px;
        }
      }
    }
  }
}
</style>
